import { render, staticRenderFns } from "./CustomerMng.vue?vue&type=template&id=13102d0c&"
import script from "./CustomerMng.vue?vue&type=script&lang=js&"
export * from "./CustomerMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports